import { FC, useState } from 'react';
import cs from 'classnames';
import styles from './index.module.less';
import MallInfo from './MallInfo/index';
import MallPassengerFlow from './NewMallPassengerFlow/index';

/**
 * 商场模块：商场信息、商场客流
 * @description 商场型商圈进行展示 !!detail.resourceMallFlag
 * @demo
 */
const Component:FC<{
  /** 商圈id */
  modelClusterId: number,
  /** 模型配置ID */
  modelConfigId: number,
  /** 商圈详情 */
  detail: any;
  className?: string,
  shareParams?: any;
  overViewData?: any;
}> = ({ modelClusterId, modelConfigId, detail, className, shareParams, overViewData }) => {
  /* state */
  const [showModule, setShowModule] = useState<boolean>(false);
  const [showMallInfo, setShowMallInfo] = useState<boolean>(false);
  /* hooks */

  /* methods */

  return (<div className={cs(styles.mallModule, className)} style={{ display: showMallInfo || showModule ? 'flex' : 'none' }}>
    {/* 评分模块见 src/common/components/business/YouthMap/AreaDetailDrawer/components/FirstScreenRight/index.tsx 的 EvaluationsXTC */}

    <MallInfo modelClusterId={modelClusterId} detail={detail} shareParams={shareParams} setShowMallInfo={setShowMallInfo} overViewData={overViewData}/>
    <MallPassengerFlow modelClusterId={modelClusterId} modelConfigId={modelConfigId} detail={detail} setShowModule={setShowModule} showModule={showModule}/>
  </div>);
};

export default Component;
